module.exports = __webpack_public_path__ + "static/media/snacks_image2.09fff023.jpg";